export default __webpack_public_path__ + "static/media/MaskGroup.ea09709e.svg";